import React, {useEffect, useState} from "react";
import {FormGroup, Label, Table} from "reactstrap";
import {ContentService} from "../../globals/services/content.service";
import Breadcrumbs from "../../globals/core/Breadcrumbs/Breadcrumb";
import {getCommunities, getUsers, setCurrentContent} from "../../store/actions/contentActions";
import {setModalChild, setModalState} from "../../store/actions/modalActions";
import {ContentItemPreview} from "./ContentItemPreview";
import {useDispatch, useSelector} from "react-redux";
import {showLoader} from "../../store/actions/mainActions";
import {AddNewContentForm} from "./AddNewContentForm";
import {QuickPostForm} from "./QuickPostForm";
import { ReactComponent as DownloadIcon } from '../../assets/images/download.svg';

export const ContentList = (props) => {

    const { me } = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    const [list, setList] = useState([]);
    const [nonFilteredlist, setNonFilteredlist] = useState([]);
    const [taglist, setTagList] = useState([]);
    const [userlist, setUserlist] = useState([]);
    const [filterField, setFilterField] = useState("");
    const [moduleSubTitle, setModuleSubTitle] = useState("");
    const [value, setValue] = useState('');

    const contentService = ContentService();

    const openContentItemPreview = (content) => {
        dispatch(setCurrentContent(content));
        dispatch(setModalState(true));
        dispatch(setModalChild(<ContentItemPreview afterPostAction={updateContentItem} />));
    };

    const openAddNewContentModal = () => {
        dispatch(setCurrentContent(undefined));
        dispatch(setModalState(true));
        dispatch(setModalChild(<AddNewContentForm afterPostAction={updateContentItem} />));
    };

    const openQuickPostForm = () => {
        dispatch(setCurrentContent(null));
        dispatch(setModalState(true));
        dispatch(setModalChild(<QuickPostForm action="create" afterPostAction={updateContentItem} />));
    }


    const updateContentItem = async () => {
        dispatch(showLoader(true))
        //await getContentItems();
        // await dispatch(getCommunities());
        // await dispatch(getUsers());
        setValue(new Date().getTime().toString());
        dispatch(showLoader(false))
    }


    const getTags = async () => {
        const tags = await contentService.getTags();
        setTagList(tags);
        return tags;
    }

    const getCreatorUsers = async () => {
        const users = await contentService.getContentItemsCreators();
        if (users) {
            setUserlist(users);
        }

        return users;
    }

    const getContentItems = async () => {

        try {
            if (me && me._id) {
                dispatch(showLoader(true));
                setModuleSubTitle("Last 20 items by " + me.fullName);
                const content = await contentService.getAdminContentItems(me._id);
                if (content) {
                    dispatch(showLoader(false));
                }
                return content.filter(c=>c.type !== 'quick_post');
            }
        } catch (err) {
            console.error(err);
        }
    }

    const searchContentItems = async (term, type) => {
        try {
            if (term && type) {
                dispatch(showLoader(true));
                if (type === 'createdBy') {
                    setModuleSubTitle("Search results for: " + userlist.find(u => u._id === term).fullName);
                } else {
                    setModuleSubTitle("Search results for: " + term);
                }
                const content = await contentService.filterAdminContentItems(term, type);
                if (content) {
                    dispatch(showLoader(false));
                }
                setList(content.filter(c=>c.type !== 'quick_post'));
                setFilterField(term);
                return content.filter(c=>c.type !== 'quick_post');
            }
        } catch (err) {
            console.error(err);
        }
    }


    const openContentItemForPreview = (e, _id) => {
        e.stopPropagation();
        console.log(_id);
        contentService.getContentItemById(_id).then((content)=>
        {
            if (content[0].type === 'file') {
                window.open(content[0].file, '_blank');
            } else if (content[0].type === 'external_link') {
                window.open(content[0].link, '_blank');
            }
        });

    };

    const searchContentItemByTitle = (e) => {
        e.preventDefault();
        searchContentItems(filterField, 'title');
    }

    useEffect(() => {
        getTags();
        getCreatorUsers();
        dispatch(getCommunities());
        dispatch(getUsers());
        getContentItems().then((res) => {
            setList(res);
            setNonFilteredlist(res);
        });
        //updateContentItem();
    }, [value, dispatch]);

    const clearFilter = (e) => {
        e.preventDefault();
        setFilterField("");
        setList(nonFilteredlist);
    }


    return (

        <div className="content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="mb-3">
                        <Breadcrumbs title="MAIN" breadcrumbItem="Content" />
                    </div>
                    <div className="col-3 d-flex ">
                        <button
                            className="btn btn-outline-primary"
                            onClick={openAddNewContentModal}
                        >
                            Create New
                        </button>
                        <button
                            className="btn btn-outline-primary mx-3"
                            onClick={openQuickPostForm}
                        >
                            Quick Post
                        </button>

                    </div>
                    <div className="col-12 d-flex">
                        <FormGroup className="mb-3 mt-3 mt-lg-0 searchByTitle">
                            <h5 className="mt-4"> <Label htmlFor="_filterField">Search content by title</Label></h5>
                            <input
                                type="text"
                                className="form-control searchByTitleInput"
                                id="filterField"
                                placeholder="Search by title"
                                onChange={(e) => setFilterField(e.target.value)}
                            />
                        </FormGroup>

                        <FormGroup className="mb-3 mt-3 mt-lg-0">
                            <button
                                className="btn btn-outline-primary adminContentBtn"
                                onClick={(e) => searchContentItemByTitle(e)}
                            >
                                Search
                            </button>
                        </FormGroup>

                        <FormGroup className="mb-3 mt-3 mt-lg-0">
                            <h5 className="mt-4"> <Label htmlFor="_filterField">Search by Tag</Label></h5>
                            OR <select className="selectInput selectInputControl" id="filterField" value={filterField ? filterField : ""} onChange={(e) => searchContentItems(e.target.value, 'tag')}>
                                <option value=""></option>
                                {
                                    taglist ? taglist.map((tag, index) => {
                                        return (
                                            <option key={index} value={tag}>{tag}</option>
                                        )
                                    }) : null
                                }
                            </select>
                        </FormGroup>

                        <FormGroup className="mb-3 mt-3 mt-lg-0">
                            <h5 className="mt-4"> <Label htmlFor="_filterField">Search by Created</Label></h5>
                            OR <select className="selectInput selectInputControl" id="filterField" value={filterField ? filterField : ""} onChange={(e) => searchContentItems(e.target.value, 'createdBy')}>
                            <option value=""></option>
                            {
                                userlist ? userlist.map((user, index) => {
                                    return (
                                        <option key={index} value={user._id}>{user.fullName}</option>
                                    )
                                }) : null
                            }
                        </select>
                        </FormGroup>

                        <FormGroup className="mb-3 mt-3 mt-lg-0">
                            <h5 className="mt-4"> <Label htmlFor="_filterField">Search by Status</Label></h5>
                            OR <select className="selectInput selectInputControl" id="filterField" value={filterField ? filterField : ""} onChange={(e) => searchContentItems(e.target.value, 'status')}>
                                <option value=""></option>
                                <option value="Active">Active</option>
                                <option value="InActive">InActive</option>
                                <option value="Archived">Archived</option>
                            </select>
                        </FormGroup>

                        <FormGroup className="mb-3 mt-3 mt-lg-0">
                            <h5 className="mt-4"> <Label htmlFor="_filterField">Search by Division</Label></h5>
                            OR <select className="selectInput selectInputControl" id="filterField" value={filterField ? filterField : ""} onChange={(e) => searchContentItems(e.target.value, 'division')}>
                                <option value=""></option>
                                <option value="All">All</option>
                                <option value="FTJ">FTJ</option>
                                <option value="HOL">HOL</option>
                                <option value="SHIHR">SHIHR</option>
                            </select>
                        </FormGroup>

                        <FormGroup className="mb-3 mt-3 mt-lg-0">
                            <button
                                className="btn btn-outline-primary mx-2 adminContentBtn"
                                onClick={(e) => clearFilter(e)}
                            >clear filter</button>
                        </FormGroup>

                    </div>


                    <div className="row justify-content-around">
                        <div className="col-12">

                            <h1>Content Management Module</h1>
                            <h4 className={"searchResults"}>{moduleSubTitle}</h4>
                            <Table responsive striped size="sm">
                                <thead>
                                <tr>
                                    <th>
                                        #
                                    </th>
                                    <th>
                                        Title
                                    </th>
                                    <th>
                                        Tags
                                    </th>
                                    <th>
                                        Status
                                    </th>
                                    <th>
                                        Type
                                    </th>
                                    <th>
                                        File Type
                                    </th>
                                    <th>
                                        Division
                                    </th>
                                    <th>
                                        Edit
                                    </th>
                                    <th>
                                        Preview
                                    </th>

                                </tr>
                                </thead>
                                <tbody className="contentTableBody">
                                {
                                    list && list.map((item, index) => {
                                        return (
                                            <tr key={item._id}>
                                                <td>{index}</td>
                                                <td className="contentTitle">{item.title}</td>
                                                <td className="contentTagsContainer">{
                                                    item.tags ? item.tags.map((tag, index) => {
                                                        return (
                                                            <span key={index} className="mr-2 contentTag" onClick={()=>searchContentItems(tag, 'tag')}>#{tag}</span>
                                                        )}) : null
                                                    }</td>
                                                <td>{item.status}</td>
                                                <td>{item.type}</td>
                                                <td>{item.file_type}</td>
                                                <td>{item.division}</td>
                                                <td><button className="contentListCTA" onClick={(e)=>openContentItemPreview(item)}>Edit</button></td>
                                                <td><DownloadIcon className="ReorderIcon" onClick={(e)=>openContentItemForPreview(e, item.content_id)}/></td>
                                            </tr>
                                        )
                                    }, [])
                                }
                                </tbody>
                            </Table>


                        </div>
                    </div>
                </div>
            </div>
        </div>


    )
}